import React, { useEffect, useState } from "react";
import { ContentContainer } from "../../../components/layout";
import {
  Button,
  Checkbox,
  DateRangePicker,
  IconButton,
  Modal,
  Select,
  Textfield,
} from "../../../components/core";
import {
  campaignStatusOptions,
  dateFilters,
  rewardType,
} from "../settings-coins/dropdown-values";
import { useQuery } from "@apollo/client";
import { QUERY_LOCKER_NAME } from "../../../constants/graphql/drop-off-graphql";
import { FETCH_ALL_CAMPAIGNS } from "../../../constants/graphql/settings-coin-queries";
import sampleData from "../../../features/coin-campaigns/sample-response.json";
import { DataTable } from "primereact/datatable";
import { paginatorTemplate } from "../settings-coins/components/paginatorTemplate";
import { Column } from "primereact/column";
import { Row } from "primereact/row";
import { Badge } from "primereact/badge";
import { ColumnGroup } from "primereact/columngroup";
import { Card } from "primereact/card";
import { useSelector } from "react-redux";
const RedemptionCodeCampaign = () => {
  // local variables
  const [filterButtonClicked, setFilterButtonClicked] = useState(false);
  const [filteredTableData, setFilteredTableData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showRedemptionCodeColumn, setShowRedemptionCodeColumn] =
    useState(true);
  const accessPermission = useSelector(
    (state) => state.accessPermissions.accessPermissions
  );
  const [selectedLockerName, setSelectedLockerame] = useState("-1");
  const [selectedCampaignName, setSelectedCampaignName] = useState("-1");
  const [selectedStatus, setSelectedStatus] = useState(-1);
  const [selectedRedemptionCode, setSelectedRedemptionCode] = useState("");
  const [campaignNameOption, setCampaignNameOptions] = useState([]);
  const [operatorID, setOperatorID] = useState("");
  const [lockerName, setLockerName] = useState([]);
  const [selectedRewardType, setSelectedRewardType] = useState("-1");
  const [selectedDateFilterValue, setSelectedDateFilterValue] = useState("-1");
  const [noResultSearch, setNoResultSearch] = useState(true);
  const [isTableEmpty, setIsTableEmpty] = useState(true);
  const [newNoData, setnewNoData] = useState(false);

  const [redemptionCodeData, setRedemptionCodeData] = useState([]);
  const [customStartDate, setCustomStartDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [customEndDate, setCustomEndDate] = useState(
    new Date().toISOString().split("T")[0]
  );

  // validation
  const [validation, setValidation] = useState({
    icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
    title: "",
    message: "",
    open: false,
  });

  const header = (type) => (
    <div className="flex items-center justify-between pr-4">
      {type === "redemptionCode" ? (
        <>
          <div>
            <Checkbox
              checked={showRedemptionCodeColumn}
              onChange={toggleRedemptionCodeColumn}
              // label={
              // 	showRedemptionCodeColumn
              // 		? "Hide Redemption Code"
              // 		: "Show Redemption Code"
              // }
              label="Show Redemption Code"
            />
          </div>
          <div className=" my-2 grid ">
            <Button
              disabled={
                accessPermission.redemptionCodeCampaign === 1 ||
                accessPermission.redemptionCodeCampaign === "1"
              }
              value={"Add "}
              className="bg-primary-primaryYellow justify-self-end px-4 shadow-md p-2  text-black "
              onClick={() => {
                window.open(
                  `${process.env.REACT_APP_BASE_ENVIRONMENT}mbox-redemption-code-campaigns/add`
                );
              }}
            ></Button>
          </div>
        </>
      ) : (
        <>
          {/* <div>
						<Checkbox
							checked={showRewardParams}
							onChange={toggleBehaviorParameter}
							label={
								showRewardParams
									? "Hide Reward Parameter"
									: "Show Reward Parameter"
							}
						/>
					</div> */}
          <div></div>
          <div className="my-2 grid ">
            <Button
              value={"Add"}
              className="bg-primary-primaryYellow justify-self-end px-4 shadow-md p-2  text-black "
              onClick={() => {
                window.open(
                  `${process.env.REACT_APP_BASE_ENVIRONMENT}mbox-coin-campaigns/add-behavioral-campaign`
                );
              }}
            ></Button>
          </div>
        </>
      )}
    </div>
  );

  const headerGroup = (type) => (
    <ColumnGroup>
      <Row>
        <Column
          header="Status"
          sortable={true}
          headerStyle={{ backgroundColor: "#FECD08" }}
          alignHeader={"center"}
          field="status"
          colSpan={1}
          rowSpan={2}
          // sortable={true}
        />
        <Column
          header="Campaign Date"
          alignHeader={"center"}
          colSpan={2}
          rowSpan={1}
          headerStyle={{ backgroundColor: "#FECD08" }}
        />
        <Column
          header="Campaign Name"
          alignHeader={"center"}
          colSpan={1}
          rowSpan={2}
          headerStyle={{ backgroundColor: "#FECD08" }}
        />
        <Column
          header="Locker Name"
          alignHeader={"center"}
          colSpan={1}
          rowSpan={2}
          headerStyle={{ backgroundColor: "#FECD08" }}
        />
        {showRedemptionCodeColumn && type === "redemptionCode" && (
          <Column
            header="Redemption Code"
            alignHeader={"center"}
            colSpan={1}
            rowSpan={2}
            headerStyle={{ backgroundColor: "#FECD08" }}
          />
        )}

        <Column
          header="Redemption Limit"
          alignHeader={"center"}
          colSpan={2}
          rowSpan={1}
          headerStyle={{ backgroundColor: "#FECD08" }}
        />

        {type === "redemptionCode" && (
          <Column
            header="Reward Type"
            alignHeader={"center"}
            colSpan={1}
            rowSpan={2}
            headerStyle={{ backgroundColor: "#FECD08" }}
          />
        )}

        {type === "behavioral" && (
          <Column
            header="Reward Behavior"
            alignHeader={"center"}
            sortable={true}
            field="rewardBehavior"
            colSpan={1}
            rowSpan={2}
            headerStyle={{ backgroundColor: "#FECD08" }}
          />
        )}

        {/* {showRewardParams && type === "behavioral" && (
					<Column
						header="Reward Parameter"
						alignHeader={"center"}
						colSpan={1}
						rowSpan={2}
						headerStyle={{ backgroundColor: "#FECD08" }}
					/>
				)} */}

        <Column
          header="Total Redemptions"
          alignHeader={"center"}
          colSpan={1}
          rowSpan={2}
          field="totalRedemptions"
          sortable={true}
          headerStyle={{ backgroundColor: "#FECD08" }}
        />
        <Column
          header=""
          alignHeader={"center"}
          field="action"
          colSpan={1}
          rowSpan={2}
          hidden={`${
            accessPermission.redemptionCodeCampaign === 1 ||
            accessPermission.redemptionCodeCampaign === "1"
              ? "hidden"
              : ""
          }`}
          headerStyle={{ backgroundColor: "#FECD08" }}
        />
      </Row>
      <Row>
        <Column
          header="Start Date"
          field="campaignStart"
          sortable={true}
          headerStyle={{ backgroundColor: "#FECD08" }}
          headerClassName="text-center"
          alignHeader={"center"}
        />
        <Column
          header="End Date"
          field="campaignEnd"
          sortable={true}
          headerClassName="text-center"
          headerStyle={{ backgroundColor: "#FECD08" }}
          alignHeader={"center"}
        />

        <Column
          header="Per Campaign "
          field="campaign"
          sortable={true}
          headerClassName="text-center"
          headerStyle={{ backgroundColor: "#FECD08" }}
          alignHeader={"center"}
        />
        <Column
          header="Per Person"
          field="person"
          sortable={true}
          headerClassName="text-center"
          headerStyle={{ backgroundColor: "#FECD08" }}
          alignHeader={"center"}
        />
      </Row>
    </ColumnGroup>
  );

  const getLockerName = (lockerIds) => {
    console.log({ lockerIds, lockerName });
    if (lockerName) {
      let lockerIdToNameMap = lockerName.reduce((acc, locker) => {
        acc[locker.value] = locker.name;
        return acc;
      }, {});

      if (
        lockerIds.length === 1 &&
        (lockerIds[0] === "0" || lockerIds[0] === 0)
      ) {
        return [{ lockerId: "0", lockerName: "All Lockers" }];
      } else {
        return lockerIds.map((id) => ({
          lockerId: id,
          lockerName: lockerIdToNameMap[id],
        }));
      }
    }
    return [];
  };

  const formatDate = (inputDate) => {
    if (inputDate == null) {
      return "";
    }

    // Remove the timezone offset from the inputDate string
    const adjustedDateString = inputDate.replace(/([+-]\d{2}:\d{2})$/, "");

    // Parse the adjusted date string
    const date = new Date(adjustedDateString);

    // Format the date to "Jul 25, 2024, 1:08 PM"
    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    };

    return date.toLocaleString("en-US", options);
  };

  const determineCampaignStatus = (item, totalRedemptions) => {
    // console.log({ item, totalRedemptions });

    const campaignEndDate = new Date(item.campaignEnd);

    const today = new Date();
    // console.log({ campaignEndDate, today });

    if (today > campaignEndDate) {
      return 2; // Assuming value 2 is for "Expired"
    }
    if (parseInt(totalRedemptions) >= parseInt(item.perCampaign)) {
      return 3; // Assuming value 3 is for "Fully Redeemed"
    } else {
      return 1; // Assuming value 1 is for "Active"
    }
  };

  // date filter functions
  function getLast30DaysRange() {
    const endDate = new Date();
    const startDate = new Date();
    startDate.setDate(endDate.getDate() - 30);
    return { startDate, endDate };
  }

  function getQuarterToDateRange() {
    const today = new Date();
    const quarterStartMonth = Math.floor(today.getMonth() / 3) * 3;
    const startDate = new Date(today.getFullYear(), quarterStartMonth, 1);
    console.log({ startDate });
    return { startDate, endDate: today };
  }

  function getYearToDateRange() {
    const today = new Date();
    const startDate = new Date(today.getFullYear(), 0, 1);
    return { startDate, endDate: today };
  }

  function getDateRange(filterValue) {
    console.log({ filterValue });
    switch (filterValue) {
      case "1":
        return getLast30DaysRange();
      case "2":
        return getQuarterToDateRange();
      case "3":
        return getYearToDateRange();
      default:
        return null;
    }
  }

  const EmptyCriteriaHandler = () => {
    console.log({ selectedStatus });
    // if selectedlockertype is all and blank yung selectedlockername
    if (selectedStatus === null) {
      setNoResultSearch(true);
      setIsTableEmpty(true);
      setnewNoData(false);
      console.log("here" + newNoData);
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: "Invalid Status",
        message: `Please select a valid campaign status.`,
        open: true,
        actions: (
          <div className="w-full">
            <Button
              onClick={() => setValidation({ open: false })}
              value={"OK"}
              className={"p-2 w-full"}
            />
          </div>
        ),
      });
      return false;
    }

    // if (selectedLockerType === "2" && selectedLockerName === "200") {
    // 	console.log("Error: No locker was found");
    // 	setNoResultSearch(true);
    // 	setIsTableEmpty(true);
    // 	setFilteredTableData([]);
    // 	setnewNoData(true);
    // 	return false;
    // }
    // setNoResultSearch(false);
    // setIsTableEmpty(false);
    // setnewNoData(false);
    setNoResultSearch(false);
    setIsTableEmpty(false);
    setnewNoData(false);
    return true;
  };

  const handleSearch = (event, data) => {
    setIsLoading(true);
    setFilterButtonClicked(true);
    // handleSearchResultHeader();
    setFilteredTableData([]);

    const showError = (title, message) => {
      setValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: title,
        message: message,
        open: true,
        actions: (
          <div className="w-full">
            <Button
              onClick={() => setValidation({ open: false })}
              value={"OK"}
              className={"p-2 w-full"}
            />
          </div>
        ),
      });
      setIsTableEmpty(true);
      setnewNoData(true);
      setIsLoading(false);
    };

    if (selectedDateFilterValue === "4") {
      if (customEndDate === "") {
        showError("Invalid Date", "No end date was selected.");
        return;
      }
      if (customStartDate > customEndDate) {
        showError("Invalid Date", "Start date must be before end date.");
        return;
      }
      if (customStartDate === "") {
        showError("Invalid Date", "No start date was selected.");
        return;
      }
    }

    const boolOne = EmptyCriteriaHandler();
    if (boolOne) {
      FilterDataTable();
    }
  };

  function FilterDataTable() {
    let totalPartners = 0;
    let totalLockers = 0;

    // Apply filters to the data
    const filterData = (data) => {
      console.log({ data });
      // if (selectedStatus) {
      return data.filter((item) => {
        const campaignStatusName = campaignStatusOptions.find(
          (status) => status.value === item.status
        )?.value;

        const campaignStatusMatch =
          selectedStatus === -1 ||
          selectedStatus === "-1" ||
          campaignStatusName.toString() === selectedStatus;

        const campaignName2 = campaignNameOption.find(
          (name) => name.value === item.campaignBehaviorId
        )?.value;

        const campaignNameMatch =
          selectedCampaignName !== "-1"
            ? campaignName2?.toString() === selectedCampaignName
            : true;
        // const campaignNameMatch = selectedCampaignName !== "-1" ?

        const lockerIdMatch =
          selectedLockerName === "-1" ||
          item.lockerName.some(
            (locker) => locker.lockerId === parseInt(selectedLockerName)
          );

        const redemptionCodeMatch =
          selectedRedemptionCode !== ""
            ? item.redemptionCode
                ?.toLowerCase()
                .includes(selectedRedemptionCode)
            : true;

        console.log({
          redemptionCodeMatch,
          selectedRedemptionCode,
        });

        const rewardTypeMatch =
          selectedRewardType === "-1" ||
          item.rewardTypeId?.toString() === selectedRewardType;

        let startDate, endDate;
        if (
          selectedDateFilterValue === "1" ||
          selectedDateFilterValue === "2" ||
          selectedDateFilterValue === "3"
        ) {
          ({ startDate, endDate } = getDateRange(selectedDateFilterValue));
        } else if (selectedDateFilterValue === "4") {
          startDate = new Date(customStartDate);
          endDate = new Date(customEndDate);
        }

        const isDateRangeMatch =
          startDate && endDate
            ? new Date(item.campaignStart) >= startDate &&
              new Date(item.campaignStart) <= endDate
            : true;

        return (
          campaignStatusMatch &&
          campaignNameMatch &&
          lockerIdMatch &&
          redemptionCodeMatch &&
          rewardTypeMatch &&
          isDateRangeMatch
        );
      });
      // } else {
      // 	return data; // If no selectedStatus, return data as-is
      // }
    };

    // Filter redemptionCodeData and behavioralData
    const filteredRedemptionData = filterData(redemptionCodeData);
    // const filteredBehaviorData = filterData(behavioralData);

    const combinedFilteredData = [
      ...filteredRedemptionData,
      // ...filteredBehaviorData,
    ];
    const isEmptyTransActions = combinedFilteredData.length === 0;

    // if (isEmptyTransActions) {
    // 	setIsLoading(false);
    // 	setIsTableEmpty(true);
    // 	setnewNoData(true);
    // } else {
    // 	setIsTableEmpty(false);
    // 	setIsLoading(false);
    // }

    setFilteredTableData(filteredRedemptionData);
    // setFilteredBehaviorTableData(filteredBehaviorData);
  }

  const toggleRedemptionCodeColumn = () => {
    setShowRedemptionCodeColumn(!showRedemptionCodeColumn);
  };

  useEffect(() => {
    const fetchOperatorID = () => {
      let opIDLocal = localStorage.getItem("user");
      let opIDLocal2 = JSON.parse(opIDLocal);
      if (opIDLocal2) {
        setOperatorID(opIDLocal2.operator_id);
      }
    };

    fetchOperatorID();
  }, []);

  // gql
  const { data: allLockerNames } = useQuery(QUERY_LOCKER_NAME, {
    variables: { operatorId: operatorID },
  });
  const getAllCampaign = useQuery(FETCH_ALL_CAMPAIGNS);

  useEffect(() => {
    if (redemptionCodeData && selectedStatus !== null) {
      const redemptionCodeCampaigns = redemptionCodeData;
      // const behavioralCampaigns = behavioralData;

      const combinedCampaigns = [
        ...redemptionCodeCampaigns,
        // ...behavioralCampaigns,
      ];
      // setCombinationCampaign(combinedCampaigns);

      const filteredCampaigns = redemptionCodeCampaigns.filter(
        (campaign) => JSON.stringify(campaign.status) === selectedStatus
      );

      console.log({ combinedCampaigns, filteredCampaigns });

      const campaignNames = filteredCampaigns.map((campaign) => ({
        name: campaign.campaignName,
        value: campaign.campaignBehaviorId,
      }));

      const allCampaigns = combinedCampaigns.map((campaign) => ({
        name: campaign.campaignName,
        value: campaign.campaignBehaviorId,
      }));

      console.log({ combinedCampaigns, allCampaigns });

      if (selectedStatus === -1 || selectedStatus === "-1") {
        setCampaignNameOptions(allCampaigns);
      } else {
        setCampaignNameOptions(campaignNames);
      }
      console.log({ campaignNameOption });
    }
  }, [redemptionCodeData, selectedStatus]);

  useEffect(() => {
    if (allLockerNames && allLockerNames.lockers) {
      let tempData = [];
      allLockerNames.lockers.forEach((element, index) => {
        tempData.push({
          value: element.lockerId,
          name: element.lockerName,
        });
      });
      setLockerName(tempData);
    }
  }, [allLockerNames]);

  // DUMMY DATA
  useEffect(() => {
    if (sampleData.data) {
      let tempData = [];
      sampleData.data.coinCampaignsReport.redemptionCode.forEach((e) => {
        let obj = { ...e };
        obj.lockerName = getLockerName(obj.lockerId);
        obj.campaignStart = formatDate(obj.campaignStart);
        obj.campaignEnd = formatDate(obj.campaignEnd);
        obj.status = determineCampaignStatus(
          obj,
          obj.redemptions ? obj.redemptions.length : 0
        );

        obj.rewardTypeId = obj.rewardType
          ? rewardType.find((x) => x.name === obj.rewardType)?.value
          : "";

        obj.totalRedemptions = obj.redemptions ? obj.redemptions.length : 0;
        tempData.push(obj);
      });

      // sampleData.data.coinCampaignsReport.behavioralCampaign.forEach((e) => {
      // 	let obj = { ...e };
      // 	obj.lockerName = getLockerName(obj.lockerId);
      // 	obj.campaignStart = formatDate(obj.campaignStart);
      // 	obj.campaignEnd = formatDate(obj.campaignEnd);
      // 	obj.status = determineCampaignStatus(
      // 		obj,
      // 		obj.redemptions ? obj.redemptions.length : 0
      // 	);

      // 	obj.totalRedemptions = obj.redemptions ? obj.redemptions.length : 0;
      // 	behaviorData.push(obj);
      // });
      // setBehavioralData(behaviorData);
      setRedemptionCodeData(tempData);
    }
  }, [sampleData.data, lockerName]);

  return (
    <>
      <ContentContainer containerTitle={"Redemption Code Campaigns"}>
        <div>
          <h2 className={"font-bold"}>Campaign:</h2>
          <div className={"grid grid-cols-2 w-1/2 gap-y-2 indent-3 pt-2"}>
            <div>Campaign Status:</div>
            <Select
              items={campaignStatusOptions}
              value={selectedStatus}
              defaultOption={{ value: -1, name: "-- All --" }}
              onChange={(e) => {
                setSelectedStatus(e.target.value);
              }}
            />

            <p>Campaign Name:</p>
            <Select
              // disabled={selectedStatus === -1}
              items={campaignNameOption}
              value={selectedCampaignName}
              defaultOption={{ value: "-1", name: "-- All --" }}
              onChange={(e) => {
                setSelectedCampaignName(e.target.value);
              }}
            />

            <p>Locker Name:</p>

            <Select
              items={lockerName}
              defaultOption={{ value: "-1", name: "-- All --" }}
              value={selectedLockerName}
              onChange={(e) => {
                setSelectedLockerame(e.target.value);
              }}
            />

            <p>Redemption Code</p>
            <Textfield
              value={selectedRedemptionCode}
              onChange={(e) => {
                setSelectedRedemptionCode(e.target.value);
              }}
              className="ml-3 w-[80%]"
              placeholder={"ABC123"}
            />

            <p>Reward Type</p>
            <Select
              // value={rewardType}
              value={selectedRewardType}
              items={rewardType}
              defaultOption={{ value: "-1", name: "-- All --" }}
              onChange={(e) => {
                setSelectedRewardType(e.target.value);
              }}
              className="w-full"
            />

            <p>Date Filter:</p>
            <Select
              items={dateFilters}
              value={selectedDateFilterValue}
              defaultOption={{ value: "-1", name: "--- All ---" }}
              onChange={(e) => {
                setSelectedDateFilterValue(e.target.value);
              }}
            />
          </div>

          <div className="grid grid-cols-7 w-[58%] pt-[8px]">
            <div></div>
            {selectedDateFilterValue === "4" && (
              <div className="col-span-5">
                <DateRangePicker
                  startDate={customStartDate}
                  endDate={customEndDate}
                  maxEnd={null}
                  onChange={(event) => {
                    if (event.target.name === "signupDateFrom") {
                      setCustomStartDate(event.target.value);
                    } else {
                      setCustomEndDate(event.target.value);
                    }
                  }}
                />
              </div>
            )}
          </div>
          <div className="flex w-[76%]">
            <div></div>
            <u
              className="flex hover:text-blue-500 cursor-pointer mt-4 ml-auto w-min"
              onClick={() => {
                setSelectedStatus(-1);
                setSelectedCampaignName("-1");
                setSelectedLockerame("-1");
                setSelectedRedemptionCode("");
                setSelectedRewardType("-1");
                setSelectedDateFilterValue("-1");
                setCustomStartDate(new Date().toISOString().split("T")[0]);
                setCustomEndDate(new Date().toISOString().split("T")[0]);
              }}
            >
              <i className="fas fa-undo my-auto"></i>
              <p className="ml-1">Reset</p>
            </u>
          </div>
          <Button
            value={"Search"}
            // disabled={behavioralData.length < 0}
            onClick={handleSearch}
            className={"w-40 h-8 m-5"}
          />
        </div>

        {!isTableEmpty && filterButtonClicked && (
          <Card>
            <DataTable
              showGridlines
              paginator
              stripedRows
              rows={10}
              sortMode="multiple"
              removableSort
              header={header("redemptionCode")}
              headerColumnGroup={headerGroup("redemptionCode")}
              value={filteredTableData}
              // tableStyle={{ minWidth: "50rem" }}
              paginatorTemplate={paginatorTemplate}
            >
              <Column
                key="status"
                field="status"
                className="text-center "
                body={(rowData) => {
                  let statusColor = "";
                  let statusName = "";

                  if (rowData.status === 1) {
                    statusColor = "bg-green-400";
                    statusName = "Active";
                  } else if (rowData.status === 2) {
                    statusColor = "bg-gray-300";
                    statusName = "Expired";
                  } else {
                    statusColor = "bg-orange-400";
                    statusName = "Redeemed";
                  }
                  return (
                    <Badge
                      className={`h-auto rounded-[3px] ${statusColor} text-secondary-purpleGray shadow-sm`}
                      value={statusName}
                    ></Badge>
                  );
                }}
              />
              <Column
                key="campaignStart"
                field="campaignStart"
                className="text-center"
              />
              <Column
                key="campaignEnd"
                field="campaignEnd"
                className="text-center"
              />
              <Column
                key="campaignName"
                field="campaignName"
                className="text-center"
              />
              <Column
                // key="lockerName"
                // field="lockerName"
                className="text-center"
                body={(rowData) => (
                  <div className="w-[250px]">
                    {rowData.lockerName.map((locker, index) => (
                      <div key={index}>{locker.lockerName} </div>
                    ))}
                  </div>
                )}
              />
              {showRedemptionCodeColumn && (
                <Column
                  key="redemptionCode"
                  field="redemptionCode"
                  className="text-center"
                />
              )}
              <Column
                key="perCampaign"
                field="perCampaign"
                className="text-center"
              />
              <Column
                key="perPerson"
                field="perPerson"
                className="text-center"
              />
              <Column
                key="rewardType"
                field="rewardType"
                className="text-center"
              />
              <Column
                key="totalRedemptions"
                field="totalRedemptions"
                className="text-center hover:underline hover:text-blue-400 hover:cursor-pointer"
                body={(rowData) => (
                  <div
                    onClick={() => {
                      // console.log("OPEN DIALOG");
                      // handleRowClick(rowData, "redemptionDetails");
                    }}
                  >
                    {rowData.totalRedemptions}
                  </div>
                )}
              />
              <Column
                key="action"
                className={`${
                  accessPermission.redemptionCodeCampaign === 1 ||
                  accessPermission.redemptionCodeCampaign === "1"
                    ? "hidden"
                    : ""
                }`}
                // headerStyle={{ backgroundColor: "#FECD08" }}
                body={(rowData) => (
                  <IconButton
                    type="button"
                    disabled
                    icon="pi pi-pencil"
                    className="bg-primary-primaryYellow flex text-black border-0 text-center justify-center items-center mr-0"
                    // onClick={() => handleRowClick(rowData, "edit")}
                    // disabled={isLoading || loading}
                  />
                )}
              />
            </DataTable>
          </Card>
        )}

        <Modal
          icon={validation.icon}
          title={validation.title}
          message={validation.message}
          open={validation.open}
          actions={validation.actions}
        />
      </ContentContainer>
    </>
  );
};

export default RedemptionCodeCampaign;
